import { useState } from "react";

import { useArtworkActions } from "@/components/admin/artwork/useArtworkActions";
import { ArtworkHeader } from "@/components/admin/artwork/ArtworkHeader";
import { ArtworkActions } from "@/components/admin/artwork/ArtworkActions";
import { ArtworkAlternatives } from "@/components/admin/artwork/ArtworkAlternatives";

/**
 * Carte de validation pour une radio (un slot du dashboard Artwork Central).
 *
 * Orchestrateur minimal : délègue la logique métier à useArtworkActions et
 * l'affichage à 3 sous-composants (Header, Actions, Alternatives).
 */
export function ArtworkCard({ item, onChanged, audio, imgVersion = 0 }) {
  const { radio, artist, title, validated, suggestions: initialSuggestions = [] } = item;
  const hasTrack = !!(artist && title);
  const [showAlt, setShowAlt] = useState(false);

  const { busy, loadingAlt, suggestions, validate, reject, fetchSuggestions } =
    useArtworkActions({ artist, title, hasTrack, onChanged, initialSuggestions });

  // Cache-buster appliqué quand l'admin clique "Actualiser" (sinon le browser
  // sert l'image cachée et la pochette ne se met pas à jour visuellement).
  const bust = (url) => (url ? `${url}${url.includes("?") ? "&" : "?"}v=${imgVersion}` : url);
  const currentArt = validated?.artwork_url || suggestions[0]?.artwork_url || radio.logo;

  const toggleAlt = () => {
    const next = !showAlt;
    setShowAlt(next);
    if (next) fetchSuggestions();
  };

  return (
    <article
      className="art-card"
      data-testid={`art-card-${radio.id}`}
      style={{ "--art-accent": radio.color }}
    >
      <ArtworkHeader
        radio={radio}
        artist={artist}
        title={title}
        hasTrack={hasTrack}
        validated={validated}
        audio={audio}
      />

      <div className="art-card-cover">
        <img src={bust(currentArt)} alt={`${artist} - ${title}`} loading="lazy" />
      </div>

      <ArtworkActions
        radioId={radio.id}
        hasTrack={hasTrack}
        busy={busy}
        loadingAlt={loadingAlt}
        validated={validated}
        suggestions={suggestions}
        onValidate={validate}
        onReject={reject}
        onToggleAlt={toggleAlt}
      />

      {showAlt && (
        <ArtworkAlternatives suggestions={suggestions} busy={busy} onValidate={validate} />
      )}
    </article>
  );
}
